import { render, staticRenderFns } from "./JellyService.vue?vue&type=template&id=46f9f0cf&scoped=true"
import script from "./JellyService.vue?vue&type=script&lang=js"
export * from "./JellyService.vue?vue&type=script&lang=js"
import style0 from "./JellyService.vue?vue&type=style&index=0&id=46f9f0cf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f9f0cf",
  null
  
)

export default component.exports